// Footer.js
const Footer = () => (
  <footer className="fixed bottom-0 w-full bg-[#dce0e8] dark:bg-[#1a1b26] py-4 text-center text-[#343b58] dark:text-[#c0caf5] shadow-lg">
    <div className="flex justify-center items-center">
      <span>Made with <em-emoji shortcodes=":heart:" set="apple"></em-emoji> by Keagan</span>
    </div>
  </footer>
 );
 
 export default Footer;